import { render } from "./StockageSelect.vue?vue&type=template&id=5d37e3ea"
import script from "./StockageSelect.vue?vue&type=script&lang=js"
export * from "./StockageSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__